module.exports = __webpack_public_path__ + "static/media/Borrower.4d0180d3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/JoinSubscription/Borrower.svg
// module id = 358
// module chunks = 0